import { faIconHref } from 'Shared/faLegacyIcon';

// The three step-line icon bullets (caution / note / reminder), as raw markup:
// the bullet selector sets them as an element's HTML. They load the same CDN
// icons that the Guide View/Edit step_text.phtml templates draw with
// faIcon(..., 16, ...). Nothing sizes the inner <svg> in CSS (.fa-svg-icon >
// svg only sets fill), so the width/height here are what size the bullet; if
// they diverge from the templates, the editor preview won't match the guide.
const ICONS = {
   icon_caution: { style: 'regular', name: 'triangle-exclamation' },
   icon_note: { style: 'regular', name: 'circle-info' },
   icon_reminder: { style: 'solid', name: 'thumbtack-angle' },
};

export function bulletIconSvg(iconName) {
   const icon = ICONS[iconName];
   if (!icon) {
      return '';
   }
   const href = faIconHref(icon.name, icon.style);
   return `<svg width="16" height="16" overflow="visible" aria-hidden="true" focusable="false"><use href="${href}" /></svg>`;
}
